import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { LocationProvider } from './contexts/LocationContext'
import NewLoginPage from './pages/NewLoginPage'
import DashboardPage from './pages/DashboardPage'
import ProductsPage from './pages/ProductsPage'
import ShoppingListsPage from './pages/ShoppingListsPage'
import ShoppingListDetailPage from './pages/ShoppingListDetailPage'
import ShoppingModePage from './pages/ShoppingModePage'
import PriceHistoryPage from './pages/PriceHistoryPage'
import Layout from './components/Layout'
import LoadingSpinner from './components/LoadingSpinner'
import StoreLocationModal from './components/StoreLocationModal'

function AppContent() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    )
  }

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/login" element={
            isAuthenticated ? <Navigate to="/" replace /> : <NewLoginPage />
          } />
          
          {/* Protected routes */}
          <Route path="/" element={
            isAuthenticated ? <Layout /> : <Navigate to="/login" replace />
          }>
            <Route index element={<DashboardPage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="shopping-lists" element={<ShoppingListsPage />} />
            <Route path="shopping-lists/:listName" element={<ShoppingListDetailPage />} />
            <Route path="shopping/:listName" element={<ShoppingModePage />} />
            <Route path="price-history" element={<PriceHistoryPage />} />
          </Route>
          
          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        
        <Toaster 
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#374151',
              color: '#fff',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
        
        {/* Global modals */}
        <StoreLocationModal />
      </div>
    </Router>
  )
}

function App() {
  return (
    <AuthProvider>
      <LocationProvider>
        <AppContent />
      </LocationProvider>
    </AuthProvider>
  )
}

export default App 